<template>
    <view-card headline="계약서목록">
        <template slot="buttons">
            <v-spacer />
            <v-col v-if="isConsole" cols="auto" class="py-0">
                <v-btn small color="secondary" @click="$emit('clickNewDocument')">수정계약서 작성 및 알림 발송</v-btn>
            </v-col>
        </template>
        <v-data-table :headers="headers" :items="documents" hide-default-footer sort-by="createdAt" sort-desc>
            <template v-slot:[`item.createdAt`]="{ item }">
                {{ item.createdAt.toDateTime() }}
            </template>
            <template v-slot:[`item.eSign.arranger`]="{ item }">
                <v-btn v-if="isConsole && item.eSign.arranger == null" :href="`https://docs.esignon.net/mail/sign?token=${item.eSign.token}`" target="_blank">서명하기</v-btn>
                <template v-else>{{ getStatus(item, "arranger") }}</template>
            </template>
            <template v-slot:[`item.eSign.employee`]="{ item }">
                <template>{{ getStatus(item, "employee") }}</template>
            </template>
            <template v-slot:[`item.eSign.employer`]="{ item }">
                <template>{{ getStatus(item, "employer") }}</template>
            </template>
            <template v-slot:[`item.document`]="{ item }">
                <template v-if="!item.eSign.employer">
                    <v-btn @click="$emit('clickShowDocument', item._id)" text x-small color="secondary" class="pa-0">
                        <v-icon>mdi-file-document-box</v-icon>
                    </v-btn>
                </template>
                <template v-else>
                    <v-btn :href="item.eSign.downloadURL" target="_blank" text x-small color="secondary" class="pa-0" style="margin-left: -6px;">
                        <v-icon class="ma-0">mdi-file-document-box</v-icon>
                    </v-btn>
                    <v-btn :href="item.eSign.certificateURL" target="_blank" text x-small color="secondary" class="pa-0">
                        <v-icon>mdi-flash-circle</v-icon>
                    </v-btn>
                </template>
            </template>
        </v-data-table>
    </view-card>
</template>
<script>
import viewCard from "../dumb/view-card.vue";

export default {
    components: { viewCard },
    props: {
        documents: { type: Array, default: [] },
    },
    data() {
        return {
            headers: [
                {
                    text: "계약서생성일",
                    value: "createdAt",
                    width: "180",
                },
                {
                    text: "계약책임자서명",
                    value: "eSign.arranger",
                },
                {
                    text: "업체서명",
                    value: "eSign.employee",
                },
                {
                    text: "고객서명",
                    value: "eSign.employer",
                },
                {
                    text: "계약서확인",
                    value: "document",
                },
            ],
        };
    },
    computed: {
        payload() {
            return this.$store.state.payload || {};
        },
        scope() {
            return this.payload.scope || [];
        },
        isConsole() {
            return this.scope.includes("console");
        },
        _user() {
            return this.payload._user;
        },
    },
    methods: {
        getStatus({ eSign }, actor) {
            const dateTime = eSign[actor + "SignedAt"]?.toDateTime();
            switch (eSign[actor]) {
                case null:
                    return "대기";
                case true:
                    return "승인" + (dateTime ? ` (${dateTime})` : "");
                case false:
                    return "반려" + (dateTime ? ` (${dateTime})` : "");
                default:
            }
        },
    },
};
</script>
